module.exports = __webpack_public_path__ + "img/disclaimer-icon.5fc0c547.svg";